import React, { useState, useCallback } from "react";
import { ListItem, CompleteCheckbox } from "@activecollab/components";
import PropTypes from "prop-types";

export const CheckboxOption = ({ name, onChange, checked: defaultChecked, children }) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleClick = useCallback(() => {
    setChecked((prevState) => {
      const nextState = !prevState;
      typeof onChange === "function" && onChange({ [name]: nextState });

      return nextState;
    });
  }, [onChange, name]);

  return (
    <ListItem onClick={handleClick}>
      {children}
      <CompleteCheckbox
        primary
        completed={checked}
        className="tw-rounded-sm tw-h-4 tw-w-4 tw-self-center"
        checkMarkClassName="tw-h-10 tw-w-10"
      />
    </ListItem>
  );
};

CheckboxOption.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  children: PropTypes.node,
};

CheckboxOption.defaultProps = {
  checked: false,
};
